import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { error } from 'protractor';
import * as XLSX from 'xlsx';
import { formConstant } from '../../../../../../config';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UploadFileService } from '../../../../../core/services/upload-file.service';
import { UserService } from '../../../../../core/services/user.service';
import {
    ICarrierItem,
    IService,
    IServiceProvider,
    IShipmentPriceItem,
    ISubService,
    IVendor
} from '../../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../../services/shipment-price.service';

@Component({
    selector: 'eci-last-mile-price-items-dialog',
    templateUrl: './price-items-dialog.component.html',
    styleUrls: ['./price-items-dialog.component.scss']
})
export class PriceItemsDialogComponent implements OnInit {
    public showLoader = false;
    public createMode: boolean = false;

    public shipmentPrice: IShipmentPriceItem;
    public vendors: IVendor[] = [];
    public services: IService[] = [];
    public subServices: ISubService[];
    public carriers: ICarrierItem[] = [];
    public serviceProvider: IServiceProvider[] = [];

    public status: any[] = [];
    public priceToCreate: any[] = [];

    public form: FormGroup;
    public title = 'Add Price List';
    public nameMaxLength = formConstant.textFieldMaxLength120;

    public searchService: FormControl = new FormControl('');
    public vendorSearch: FormControl = new FormControl('');
    public carrierSearch: FormControl = new FormControl('');
    public subServiceSearch: FormControl = new FormControl('');
    public file: any;
    public isFulfilment = false;
    private currentServiceName: string = undefined;

    constructor(public dialogRef: MatDialogRef<PriceItemsDialogComponent>,
                public userSvc: UserService,
                private notify: NotificationService,
                private shipmentPriceSvc: ShipmentPriceService,
                public uploadFileSvc: UploadFileService,
    ) {}

    ngOnInit(): void {
        this.form = this.initializeForm();
        if (this.createMode) {
        // TODO: Add Filter or selected data

/*      this.subscriber('vendorId', 'services', 'service');
            this.subscriber('serviceId', 'subServices', 'sub-service');
            if (!this.isFulfilment) {
                this.subscriber('serviceId', 'carriers', 'carriers');
        }
 */
            this.setRelation();
        }
    }

    private setRelation(): void {
        this.form?.get('vendorId')?.valueChanges
            .subscribe((value) => {
                if (this.form?.get('serviceId').value || this.form?.get('subServiceId').value) {
                    this.notify.showWarn('After changing the vendor, the services and subServices are cleared');
                }
                this.form.value.serviceId = undefined;
                this.form.value.subServiceId = undefined;
                this.form.value.carrierId = undefined;
                this.form.value.providerName = undefined;

                this.form.controls.serviceId.enable();
                this.form.controls.subServiceId.disable();
                this.form.controls.carrierId.disable();
                this.form.controls.providerName.disable();
            });
        this.form?.get('serviceId')?.valueChanges
            .subscribe((value) => {
                this.form.value.subServiceId = undefined;
                this.form.controls.subServiceId.enable();

                if (!value) {
                    return;
                }

                const service = this.services.find((s) => s.id === value);
                if (service.name === 'LAST MILE') {
                    this.isFulfilment = false;
                    this.form.controls.providerName.disable();
                    this.form.controls.carrierId.enable();
                    this.form.value.carrierId = undefined;
                } else {
                    this.isFulfilment = true;
                    this.form.controls.providerName.enable();
                    this.form.controls.carrierId.disable();
                    this.form.value.providerName = undefined;

                }
            });
    }

    private initializeForm(): FormGroup {
        console.log(this.shipmentPrice);
        return new FormGroup({
            vendorId: new FormControl({
                disabled: !this.createMode,
                value: this.shipmentPrice?.vendorId,
            }, [Validators.required]),
            serviceId: new FormControl({
                    disabled: (!this.shipmentPrice?.vendorId || !this.createMode),
                    value: this.shipmentPrice?.serviceId,
                },
                [Validators.required]),
            subServiceId: new FormControl({
                    disabled: (!this.shipmentPrice?.serviceId || !this.createMode),
                    value: this.shipmentPrice?.subServiceId,
                },
                [Validators.required]),
            carrierId: new FormControl({
                disabled: (!this.shipmentPrice?.serviceId || !this.createMode),
                value: this.shipmentPrice?.assetServiceProviderId,
            }, [Validators.required]),
            providerName: new FormControl({
                disabled: (!this.shipmentPrice?.serviceId || !this.createMode),
                value: this.shipmentPrice?.serviceProvider?.name || '',
            }, [Validators.required]),
            createdBy: new FormControl({disabled: true, value: this.shipmentPrice?.createdBy}),
        });
    }

/*    private subscriber(fieldName: string, listName: string, path): void {
        this.form?.get(fieldName)?.valueChanges
            .subscribe((value) => {
                if (value) {
                    this.getParams(path, listName, {[fieldName]: value});
                }
            });
    }*/

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    public onNoClick(): void {
        this.dialogRef.close();

    }

    public onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }
        this.getCurrentServiceName();
        this.uploadFile()
            .then((fileId: number) => {
                if (this.createMode) {
                    this.save(this.form.value, fileId);
                } else {
                    this.update(this.shipmentPrice?.id, this.form.value, fileId);
                }
            });
    }

    private save(shipmentPrice: IShipmentPriceItem, fileId: number): void {
        if (!shipmentPrice) {
            return;
        }
        this.showLoader = true;
        shipmentPrice.createdBy = this.userSvc.user.email;
        shipmentPrice.priceList = this.priceToCreate;
        shipmentPrice.fileId = fileId;
        this.shipmentPriceSvc.create<IShipmentPriceItem>('shipment-price', shipmentPrice).subscribe((p) => {
            this.notify.showSuccessMessage(`Created successfully`);
            this.dialogRef.close(this.form.value);
        }, this.errorHandler);
    }

    private update(id: number, shipmentPrice: IShipmentPriceItem, fileId: number): void {
        if (!shipmentPrice) {
            return;
        }
        this.showLoader = true;
        shipmentPrice.priceList = this.priceToCreate;
        shipmentPrice.fileId = fileId;
        this.shipmentPriceSvc.update<IShipmentPriceItem>('shipment-price', id, shipmentPrice).subscribe((v) => {
            this.notify.showSuccessMessage(`Update successfully`);
            this.dialogRef.close(this.form.value);
        }, this.errorHandler);
    }

    private errorHandler = (err) => {
        if (err?.status === 422) {
            this.notify.showWarn(err?.error?.message);
            this.dialogRef.close(this.form.value);
        } else {
            this.notify.showError(err?.error?.message);
        }
        this.showLoader = false;
    }

    public uploadFile(): Promise<number> {
        return new Promise((resolve, reject) => {
            this.shipmentPriceSvc.uploadFile(this.file, undefined, this.currentServiceName)
            this.shipmentPriceSvc.fileLoadedObserver.subscribe((data) => {
                if (!data) {
                    return;
                }
                resolve(JSON.parse(data)?.id);
            }, (err) => {
                this.notify.showError(err.message);
                this.showLoader = false;
                reject();
            });
        });
    }

    public upload(event): void {
        this.showLoader = true;
        const files = event.target.files;
        if (!files || files.length === 0) {
            return;
        }

        this.file = files[0];
        if (!this.uploadFileSvc.excelFileFormats[0].includes(this.file.type)) {
            this.notify.showError('Please upload a excel file only.');
            event.target.value = '';
            this.showLoader = false;
            return;
        }
        const fileReader = new FileReader();
        fileReader.readAsBinaryString(this.file);
        fileReader.onload = function(f) {
            const workbook = XLSX.read(<string> fileReader.result, {type: 'binary', cellDates: true, cellStyles: true});

            const sheetName = workbook.SheetNames;
            const priceListInText: any[] = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName[0]], { raw: false });
            const priceList: any[] = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName[0]]);

            this.updateMargin(priceList, priceListInText);
            const priceToCreate = [];
            priceList.forEach((p) => {
                let price = {};
                if (this.isFulfilment) {
                    price = this.getFulfilmentPrice(p);
                } else {
                    price = this.getShipmentPrice(p);
                }
                priceToCreate.push(price);
            });
            if (priceToCreate.length === 0) {
                this.notify.showWarn('Cant find valid data in file');
                event.target.value = '';
                this.file = undefined;
                this.showLoader = false;
                return false;
            }
            this.priceToCreate = priceToCreate;
            this.showLoader = false;
        }.bind(this);
        fileReader.onerror = () => {
            event.target.value = '';
        };
    }

    protected getShipmentPrice(price): any {
        const dynamicData = {};
        Object.keys(price).forEach((key) => {
            if (key.includes('Weight')) {
                Object.assign(dynamicData, {weight: price[key]});
                const match = key.match(/\(([^)]+)\)/);
                Object.assign(dynamicData, {unitOfMeasurement: match?.[1]});
            }
        });
        const zoneValues = Object.entries(price)
            .filter(([key]) => key.startsWith('Zone'))
            .map(([key, value]) => ({cost: value, name: key}));
        return {
            destination: price['Destination*'],
            costNetRates: price['Cost Net Rates*'],
            margin: price['Margin %*'],
            sellPrice: price['Sell Price*'],
            unit: price['Unit*'],
            subCarrier: price['Sub Carrier'],
            currency: price['Currency*'],
            prices: zoneValues,
            ...dynamicData,
        };
    }

    protected getFulfilmentPrice(price): any {
        return {
            typeName: price['Type*'],
            subTypeName: price['Sub Type*'],
            description: price['Fulfillment Charge Description*'],
            activityUnitName: price['Unit Measure*'],
            costRates: price['Cost Rates*'],
            margin: price['Margin %*'],
            sellPrice: price['Sell Price*'],
            currency: price['Currency*'],
            maxLength: price['Length*'],
            maxWidth: price['Width*'],
            maxHeight: price['Height*'],
            dimensionsUnitsOfMeasure: price['Dimensions Unit Measure*'],
            maxWeight: price['Gross Weight*'],
            weightUnitsOfMeasure: price['Weight Unit Measure*'],
            maxVolume: price['Volume*'],
            volumeUnitsOfMeasure: price['Volume Unit Measure*'],
        };
    }

    protected getCurrentServiceName() {
        const service = this.services.find((s) => s.id === this.form.value.serviceId);
        this.currentServiceName = this.getCurrentCapitalizeName(service.name);
    }

    private getCurrentCapitalizeName(stringName: string = undefined): string {
        if (!stringName) {
            return;
        }
        let currentName: string = '';
        const names: string[] = stringName.split(' ');
        if (names.length > 1) {
            names.forEach((n) => {
                currentName += this.capitalizeFirstLetter(n);
            });
        } else {
            currentName = this.capitalizeFirstLetter(stringName);
        }

        console.log('getCurrentCapitalizeName', currentName)
        return currentName;
    }

    private capitalizeFirstLetter(string: string): string {
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    }

    private updateMargin(priceList: any[], priceListInText: any[]): void {
        priceList.forEach((price, index) => {
            price['Margin %*'] = priceListInText[index]['Margin %*']?.replace('%', '');
        });
    }
}
